<template>
  <div>
    <vs-popup
  class="holamundo"
  title="New User"
  :active.sync="popupActive"
>
  <!-- USER NAME -->
  <div class="vx-row mb-4">
    <div class="vx-col sm:w-1/3 w-full topPad">
      <span class="popup_lbl inputStyles">User Name</span>
    </div>

    <div class="vx-col sm:w-1/2 w-full">
      <vs-input
        class="inputx w-full"
        v-model="form.userName"
      />
    </div>
  </div>

  <!-- PASSWORD -->
  <div class="vx-row mb-4">
    <div class="vx-col sm:w-1/3 w-full topPad">
      <span class="popup_lbl inputStyles">Password</span>
    </div>

    <div class="vx-col sm:w-1/2 w-full">
      <vs-input
        type="password"
        class="inputx w-full"
        :disabled="form.userId != ''"
        v-model="form.password"
      />
    </div>
  </div>

  <!-- PHONE -->
  <div class="vx-row mb-4">
    <div class="vx-col sm:w-1/3 w-full topPad">
      <span class="popup_lbl inputStyles">Phone No</span>
    </div>

    <div class="vx-col sm:w-1/2 w-full">
      <vs-input
        class="inputx w-full"
        v-model="form.phoneNo"
      />
    </div>
  </div>

  <!-- CATEGORY -->
 
<div class="vx-row mb-4">

  <div class="vx-col sm:w-1/3 w-full topPad">
    <span class="popup_lbl inputStyles">Category</span>
  </div>

  <div class="vx-col sm:w-1/2 w-full">

    <select
      v-model="form.categoryId"
      class="vs-select--input myselect"
      style="height:36px"
    >

      <option
        v-for="(item, index) in userCategoryList"
        :key="index"
        :value="item.id"
      >
        {{ item.name }}
      </option>

    </select>

  </div>

</div>
  <!-- DOCTOR -->
  <div class="vx-row mb-4">
    <div class="vx-col sm:w-1/3 w-full topPad">
      <span class="popup_lbl inputStyles">Doctor</span>
    </div>

    <div class="vx-col sm:w-1/2 w-full">

    <select
  v-model="form.doctorId"
  class="vs-select--input myselect"
  style="height:36px"
>

  <option value="">
    Select
  </option>

  <option
    v-for="(item, index) in doctorList"
    :key="index"
    :value="item.id"
  >
    {{ item.name }}
  </option>

</select>

    </div>
  </div>

  <!-- ACTIVE -->
  <div class="vx-row mb-4">
    <div class="vx-col sm:w-1/3 w-full topPad">
      <span class="popup_lbl inputStyles">Active</span>
    </div>

    <div class="vx-col sm:w-1/2 w-full">
      <vs-checkbox v-model="form.enabled">
        Active
      </vs-checkbox>
    </div>
  </div>

  <!-- BUTTONS -->
  <div class="vx-row mb-4 popup_btn">

  <vs-button
  color="primary"
  type="border"
  style="margin-right: 15px"
  @click="saveUser"
>
  Save
</vs-button>

    <vs-button
      color="warning"
      type="border"
      
      @click="clearFields"
    >
      Clear
    </vs-button>

  </div>

</vs-popup>
    <vx-card>

      <!-- HEADER -->
      <div class="vx-row card-header-row">
        <div>
          <vs-button color="success" type="border" @click="openForm">
            New
          </vs-button>
        </div>

        <div>
             <feather-icon
            icon="XIcon"
            class="custom-class"
            style="width: 20px; height: 20px; color: #009696; cursor: pointer"
            title="Close"
            @click="exit"
          />
        </div>
      </div>

 <vue-good-table
  mode="remote"
  :rows="users"
  :columns="columns"
  :totalRows="totalRecords"
  :pagination-options="{ enabled: true, perPage: 7 }"
  :sort-options="{ enabled: false }"
  :isLoading.sync="isLoading"
  @on-page-change="onPageChange"
  styleClass="vgt-table condensed"
    @on-row-dblclick="onRowDoubleClick"
>

  <template slot="table-row" slot-scope="props">

    <span v-if="props.column.field === 'activeFlag'">

      <span
        v-if="props.row.activeFlag === 'Y'"
        style="color: green;"
      >
        Active
      </span>

      <span
        v-else
        style="color: red;"
      >
        Inactive
      </span>

    </span>

    <span v-else>
      {{ props.formattedRow[props.column.field] }}
    </span>

  </template>

</vue-good-table>

    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      userCategoryList: [{ id: "", name: "Select" }],
      users: [],
      totalRecords: 0,

      serverParams: {
        companyId: this.$session.get("companyId"),
        filter: {},
        currentPage: 1,
        limit: 7,
      },
      popupActive: false,

form: {
  userId: "",
  userName: "",
  password: "",
  phoneNo: "",
  categoryId: "",
  doctorId: "",
  enabled: true,
},
doctorList: [],
      columns: [
        { label: "USER NAME", field: "userName" },
        { label: "ROLE", field: "categoryName" },
        { label: "PHONE", field: "phoneNo" },
        { label: "STATUS", field: "activeFlag" },
      ],
    };
  },

  mounted() {
  
      this.getDoctorList();
      this.getUserCategoryList();
  },

  methods: {
    loadUsers() {
      this.isLoading = true;

      this.$http
        .post("getUserDashboard", JSON.stringify(this.serverParams), {
          headers: { "Content-Type": "application/json" },
        })
        .then((res) => {
          this.users = res.data.data;
            this.users.forEach((user) => {

    let category = this.userCategoryList.find(
      x => x.id == user.userCategoryId
    );

    user.categoryName = category ? category.name : "";

  });

          this.totalRecords = res.data.recordsTotal;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onPageChange(params) {
      this.serverParams.currentPage = params.currentPage;
      this.loadUsers();
    },
    onRowDoubleClick(params) {

  const row = params.row;

  this.form.userId = row.userId;

  this.form.userName = row.userName;

  this.form.phoneNo = row.phoneNo;

  this.form.categoryId = row.userCategoryId;

  this.form.enabled = row.activeFlag === "Y";

   this.form.doctorId = row.doctorId;
  this.form.password = "********";

  this.popupActive = true;
},

    openForm() {
      this.popupActive = true;
    },
  clearFields() {

  if(this.form.userId){

    this.form.userName = "";
    this.form.phoneNo = "";
    this.form.categoryId = "";
    this.form.doctorId = "";
    this.form.enabled = true;

  }else{

    this.form = {
      userId: "",
      userName: "",
      password: "",
      phoneNo: "",
      categoryId: "",
      doctorId: "",
      enabled: true,
    };

  }
},
getDoctorList() {

  let request = {
    companyId: this.$session.get("companyId"),
  };

  this.$http
    .post(
      "getdoctorlist",
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {

      this.doctorList = res.data.data;

    });

},
getUserCategoryList() {

  var request = {
    companyId: this.$session.get("companyId"),
  };

  this.$http
    .post("getUserCategoryList", JSON.stringify(request), {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {

      response.data.data.forEach((element) => {
        this.userCategoryList.push(element);
      });

    });
      this.loadUsers();
},
saveUser() {

  let request = {
   userId: this.form.userId,
    userName: this.form.userName,

    password: this.form.password,

    phoneNo: this.form.phoneNo,

    companyId: this.$session.get("companyId"),

    userCategoryId: this.form.categoryId,

    doctorId: this.form.doctorId,

    enabled: this.form.enabled,
  };

  this.$http
    .post(
      "saveUser",
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {

      this.$vs.notify({
        color: "success",
        title: "Success",
        text: "User Saved Successfully",
      });

      this.popupActive = false;

      this.clearFields();

      this.loadUsers();

    })
    .catch((err) => {

      this.$vs.notify({
        color: "danger",
        title: "Error",
        text: err.response.data.message,
      });

    });

},
    exit() {
      this.$router.push("/Master");
    },
  },
};
</script>


<style>
.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}
.vgt-table thead th {
  background: white;
}

.vgt-wrap__footer {
  background: white;
}

table.vgt-table {
  font-size: 12px;
  border: none;
}

.vgt-right-align {
  text-align: left;
}

.vgt-table.condensed tr {
  height: 56px;
}

.vgt-table.condensed td {
  padding-top: 19px;
}

.vgt-input {
  border: none;
}

.vgt-wrap__footer {
  border: none;
}
.popup_btn {
  margin-left: 100px;
  padding-left: 98px;
}
</style>